import { render, staticRenderFns } from "./DayGame.vue?vue&type=template&id=c585f072"
import script from "./DayGame.vue?vue&type=script&lang=ts"
export * from "./DayGame.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports